import { FormArray, FormControl, FormGroup } from '@angular/forms';

export class FormValidation {
  static validateAllFormFields(form: FormGroup | FormArray): void {
    if (!form || !form.controls) {
      return;
    }

    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
        control.updateValueAndValidity();
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
